export default __webpack_public_path__ + "static/media/sharing.68b18354.svg";